export default {
  h1: {
    fontWeight: 700,
    fontSize: 35,
    fontFamily: "Good Times W00 Bold",
    letterSpacing: "1.6px",
    "@media(max-width:767px)": {
      fontSize: "25px !important",
      lineHeight: "40px",
    },
  },
  h2: {
    fontWeight: 700,
    fontSize: 32,
    fontFamily: "Good Times W00 Bold",
    lineHeight: "45px",
    "@media(max-width:767px)": {
      fontSize: "23px !important",
    },
  },
  h3: {
    fontWeight: 500,
    fontSize: 25,
    fontFamily: "'Sora', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "20px !important",
    },
  },
  h4: {
    fontWeight: 500,
    fontSize: 22,
    fontFamily: "'Sora', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "18px !important",
    },
  },
  h5: {
    fontWeight: 400,
    fontSize: 18,
    fontFamily: "'Sora', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "16px !important",
    },
  },
  h6: {
    fontWeight: 400,
    fontSize: 16,
    fontFamily: "'Sora', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "14px !important",
    },
  },
  overline: {
    fontWeight: 500,
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
  },
  body1: {
    fontSize: 16,
    fontWeight: 300,
    color: "rgba(255, 255, 255, 0.6)",
    fontFamily: "'Sora', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "12px !important",
    },
  },
  subtitle1: {
    fontSize: 11,
    fontFamily: "'Sora', sans-serif",
    fontWeight: 300,
  },
  body2: {
    fontSize: 14,
    fontFamily: "'Sora', sans-serif",
    fontWeight: 300,
    "@media(max-width:767px)": {
      fontSize: "12px !important",
    },
  },
};
